"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateRangePickerDefaultProps = exports.ISO_8601 = exports.DEFAULT_WEEK_START_DAY = exports.DEFAULT_DATE_FORMAT = void 0;
var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
exports.DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
var DEFAULT_WEEK_START_DAY = 0; // Sunday

exports.DEFAULT_WEEK_START_DAY = DEFAULT_WEEK_START_DAY;
var ISO_8601 = 'iso8601';
exports.ISO_8601 = ISO_8601;
var dateRangePickerDefaultProps = {
  shouldFocusOnStartDate: false,
  ariaLabelsForSelectedDate: {
    startDate: 'Range start date selected',
    endDate: 'Range end date selected',
    startDateFocus: 'You are currently focusing on the selected start date',
    endDateFocus: 'You are currently focusing on the selected end date'
  }
};
exports.dateRangePickerDefaultProps = dateRangePickerDefaultProps;